import instance from "@/utils/require.js"

// 客户管理--客户分页查询
export function apiBlueWayItemCodeUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/blue_way/item_code/update",
		method: "post",
		data
	})
}
export function apiBlueWayItemCodeSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/blue_way/item_code/search",
		method: "post",
		data
	})
}
export function apiBlueWayOrderSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/blue_way/order/search",
		method: "post",
		data
	})
}
export function apiBlueWayStockRecordSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/blue_way/stock_record/search",
		method: "post",
		data
	})
}